export const handleLocaleClick = async (locale: string) => {
  try {
    await fetch(`/api/profiles/updateLocale`, {
      method: "POST",
      body: JSON.stringify({
        locale: locale,
      }),
    });
    return;
  } catch (err) {
    if (err instanceof Error && err.message === "UNAUTHORIZED") {
      return; // already handled by redirect
    }
    const errorMessage =
      err instanceof Error ? err.message : "An unexpected error occurred.";
    return;
  }
};

export const handleCreateHandoff = async () => {
  try {
    const response = await fetch(`/api/auth/getHandoffToken`, {
      method: "POST",
    });
    if (response.ok) {
      const data = (await response.json()) as { code: string };
      console.log(data);
      return data.code;
    }
    console.log(response);
    return;
  } catch (err) {
    console.log(err);
    if (err instanceof Error && err.message === "UNAUTHORIZED") {
      return; // already handled by redirect
    }
    const errorMessage =
      err instanceof Error ? err.message : "An unexpected error occurred.";
    return;
  }
};
